import { useState, useEffect } from 'react';

export interface ColumnDefinition {
	id: string;
	label: string;
	isVisible: boolean;
	width?: string;
}

export const useColumnPreferences = (key: string, defaultColumns: ColumnDefinition[]) => {
	const [columns, setColumns] = useState<ColumnDefinition[]>(() => {
		try {
			const saved = localStorage.getItem(`columns_${key}`);
			if (saved) {
				const parsed = JSON.parse(saved);
				// Merge saved with default to handle potential new columns in code updates
				return defaultColumns.map(col => {
					const savedCol = parsed.find((p: ColumnDefinition) => p.id === col.id);
					return savedCol ? { ...col, isVisible: savedCol.isVisible } : col;
				});
			}
		} catch (e) {
			console.error("Failed to load column preferences", e);
		}
		return defaultColumns;
	});

	useEffect(() => {
		try {
			localStorage.setItem(`columns_${key}`, JSON.stringify(columns));
		} catch (e) {
			console.error("Failed to save column preferences", e);
		}
	}, [columns, key]);

	const toggleColumn = (id: string) => {
		setColumns(prev => prev.map(col =>
			col.id === id ? { ...col, isVisible: !col.isVisible } : col
		));
	};

	return { columns, toggleColumn };
};
